import React from 'react';
import {
  Button, Modal, InputGroup, FormControl,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import FieldSet from '../fieldset/FieldSet';
import Confirm from '../confirm/Confirm';
import BtpsService from '../../service/BraintreePaymentService';
import { buildSuccessStatus, buildFailureStatus, } from '../constants/AlertConstants';

class CancelAchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onCancelAchClick() {
    const { id, } = this.props;
    return BtpsService.cancelTransaction(id)
      .then(() => {
        this.setState({
          status: buildSuccessStatus(`ACH Transaction ID: ${id} was successfully cancelled.`, () => this.onDismiss()),
        });
      })
      .catch(() => {
        this.setState({
          status: buildFailureStatus(`Unable to cancel ACH Transaction ID: ${id}.`, () => this.onDismiss()),
        });
      });
  }

  onDismiss() {
    this.setState({
      status: null,
    });
  }

  onConfirmationOpen() {
    this.setState({
      isConfirming: true,
    });
  }

  onConfirmationClose() {
    this.setState({
      isConfirming: false,
    });
  }

  reset() {
    this.setState({
      isConfirming: false,
      status: null,
      show: false,
      isLoading: false,
    });
  }

  handleShow() {
    this.setState({
      show: true,
    });
  }

  handleClose() {
    this.setState({
      show: false,
    });
    this.reset();
  }

  render() {
    const {
      show, isConfirming, isLoading, status,
    } = this.state;
    const {
      modalSize, title, id, buttonLbl,
    } = this.props;
    return (
      <div>
        <Button variant="primary" onClick={() => this.handleShow()}>
          {buttonLbl}
        </Button>
        <Modal show={show} onHide={() => this.handleClose()} size={modalSize}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FieldSet title="Cancel Pending ACH">
              <InputGroup className="mt-2">
                <FormControl value={id} readOnly />
                <Button variant="danger" onClick={() => this.onConfirmationOpen()}>
                  Cancel
                </Button>
                <Confirm
                  isLoading={isLoading}
                  title="Cancel Pending ACH"
                  content="Are you sure you want to remove cancel this transaction?"
                  open={isConfirming}
                  onClose={() => this.onConfirmationClose()}
                  onYes={() => {
                    this.setState({
                      isLoading: true,
                    });
                    this.onCancelAchClick().finally(() => {
                      this.setState({
                        isConfirming: false,
                        isLoading: false,
                      });
                    });
                  }}
                  onNo={() => this.onConfirmationClose()}
                />
              </InputGroup>
            </FieldSet>
            {status}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

CancelAchForm.defaultProps = {
  title: 'Cancel ACH Account Form',
  buttonLbl: 'Cancel ACH',
  modalSize: 'xl',
};

CancelAchForm.propTypes = {
  title: PropTypes.string,
  modalSize: PropTypes.string,
  id: PropTypes.string.isRequired,
  buttonLbl: PropTypes.string,
};

export default CancelAchForm;
